import styled from "styled-components";

export const ModalContent = styled.div`
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 16px;
  overflow: hidden;

  @media (max-width: 768px) {
    max-width: 100%;
    max-height: 85vh;
  }

  @media (max-width: 480px) {
    max-height: 90vh;
  }
`;

export const YellowBanner = styled.div`
  background-color: #FFD700;
  padding: 10px 18px;
  text-align: center;
  position: relative;
  z-index: 2;
  border-radius: 12px 12px 0 0;
  flex-shrink: 0;

  @media (max-width: 768px) {
    padding: 9px 15px;
  }

  @media (max-width: 480px) {
    padding: 8px 12px;
  }
`;

export const BannerText = styled.div`
  color: #0066FF;
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1.4;

  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

export const GradientContainer = styled.div`
  background: linear-gradient(90deg, #6B46C1 0%, #10B981 100%);
  position: relative;
  padding: 25px 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  border-radius: 0 0 16px 16px;
  overflow: hidden;
  flex: 1;
  min-height: 0;
  box-sizing: border-box;

  /* Dot pattern overlay */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: radial-gradient(circle, rgba(255, 255, 255, 0.2) 1px, transparent 1px);
    background-size: 20px 20px;
    opacity: 0.3;
    pointer-events: none;
  }

  @media (max-width: 768px) {
    padding: 20px 18px 18px;
    gap: 10px;
  }

  @media (max-width: 480px) {
    padding: 18px 15px 15px;
    gap: 8px;
  }
`;

export const MainText = styled.div`
  color: #FFFFFF;
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  line-height: 1.2;
  
  z-index: 1;
  position: relative;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 1.2;
  }

  @media (max-width: 480px) {
    font-size: 20px;
    line-height: 1.2;
  }
`;

export const CopyLabel = styled.div`
  color: #E5E7EB;
  font-size: 11px;
  text-align: center;
  z-index: 1;
  position: relative;
  margin-top: -8px;
  margin-bottom: -5px;

  @media (max-width: 480px) {
    font-size: 10px;
    margin-top: -6px;
    margin-bottom: -3px;
  }
`;

export const ReferralCodeBox = styled.div`
  background-color: #F3F4F6;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  padding: 12px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  max-width: 350px;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 1;
  position: relative;
  box-sizing: border-box;

  &:hover {
    background-color: #E5E7EB;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    max-width: 320px;
    padding: 10px 16px;
    gap: 10px;
  }

  @media (max-width: 480px) {
    max-width: 100%;
    width: 100%;
    padding: 10px 15px;
    gap: 10px;
  }
`;

export const ReferralCode = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  letter-spacing: 1px;
  flex: 1;
  text-align: left;

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

export const CopyIcon = styled.div`
  color: #6B7280;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const CopiedText = styled.div`
  color: #10B981;
  font-size: 13px;
  font-weight: 600;
  z-index: 1;
  position: relative;
  margin-top: -12px;
  margin-bottom: -5px;

  @media (max-width: 480px) {
    font-size: 11px;
    margin-top: -10px;
    margin-bottom: -3px;
  }
`;

export const WhatsAppSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 100;
  position: relative;
  margin-top: 2px;
  margin-bottom: -3px;

  @media (max-width: 480px) {
    gap: 6px;
    margin-top: 0;
    margin-bottom: -2px;
  }
`;

export const WhatsAppLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  font-size: 24px;

  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

export const WhatsAppLabel = styled.div`
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 500;

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

export const WhatsAppButton = styled.button`
  background-color: #28A949;
  color: #FFFFFF;
  border: none;
  border-radius: 12px;
  padding: 14px 35px;
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 1;
  position: relative;
  width: 100%;
  max-width: 350px;
  box-sizing: border-box;

  &:hover {
    background-color: #22943D;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(40, 169, 73, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 12px 30px;
    font-size: 14px;
    max-width: 320px;
  }

  @media (max-width: 480px) {
    padding: 12px 25px;
    font-size: 13px;
    max-width: 100%;
  }
`;

export const FooterDisclaimer = styled.div`
  color: #E5E7EB;
  font-size: 10px;
  text-align: center;
  line-height: 1.4;
  z-index: 1;
  position: relative;
  margin-top: 5px;
  max-width: 400px;
  padding: 0 10px;

  @media (max-width: 768px) {
    font-size: 9px;
    max-width: 350px;
    margin-top: 3px;
  }

  @media (max-width: 480px) {
    font-size: 9px;
    max-width: 100%;
    padding: 0 5px;
    margin-top: 2px;
  }
`;

export const ImgMascot = styled.img`
  width: 120px;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const List = styled.ul`
  width: 100%;
  display: flex;
  justify-content: space-between;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 20px;

  &.justify-around {
    justify-content: space-around;
  }
`;

export const Item = styled.li`
  a {
    text-decoration: none;
  }
  p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    margin-top: 4px;
    color: #b3b3b3;
    font-size: 12px;
    line-height: 16px;
  }
`;